import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-delete-devicegroup.hbs';

    var globalCh = Radio.channel('global');

    var DeleteDeviceGroupDialog = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        initialize: function(options) {
            this.destroyOnClose();
            this.focusFirstInput();
        },
        ui: {
            alert: '.modal-alert-container > .alert',
            alert_container: '.modal-alert-container',
            submit_btn: 'button[type="submit"]'
        },
        events: {
            'submit form': 'on_submit',
        },
        templateContext: function(){
            return {
                devicegroup_type : this.model.type_readable()
            };
        },
        on_submit: function(e) {
            e.preventDefault();
            this.hideAlert();
            this.model.destroy({
                wait: true,
                success: _.bind(this.on_success, this),
                error: _.bind(this.on_error, this),
            });
        },
        on_success: function(devicegroup) {
            globalCh.request(
                'layout_alert',
                'Deleted  ' + this.model.type_readable() + ': '  +  devicegroup.get('name'),
                'success',
                5000
            );
            this.closeDialog();
            if (this.options.success) this.options.success(this.model);
        },
        on_error: function(product, resp) {
            var errors = ['An error occurred while attempting to delete this Device Group.'];
            if (resp 
             && resp.responseJSON 
             && resp.responseJSON.errors
             && resp.responseJSON.errors.length
            ) {
                errors = _.map(resp.responseJSON.errors, function(err) {
                    if (err.code === 'CX010') {
                        err.detail = "Cannot delete a Device Group with Promoted Deployments. See Deployments.";
                    }
                    return err.detail;
                });
            }

            this.showAlert('error', errors.join(' '));
        }
    });
    export default DeleteDeviceGroupDialog;

